/**
 * Flair — petits correctifs globaux (audit SEO / UX d'octobre 2026).
 *
 * 1. Barre « Ajouter au panier » collante sur téléphone.
 *    La règle de Focal ne l'affichait qu'après avoir dépassé le bouton ET tant que le pied de page n'était pas
 *    visible : sur nos fiches courtes, les deux arrivent en même temps, la barre ne s'affichait donc jamais.
 *    Nouvelle règle (téléphone uniquement) : la barre apparaît quand le client a fait défiler la page au-delà du vrai
 *    bouton, tant que celui-ci n'est pas à l'écran. Elle se cache au-dessus du pied de page.
 *
 * 2. Texte de collection repliable (sections/fx-coldesc.liquid) : bouton « Lire la suite ».
 *
 * 5. Délai de livraison (voyant de stock « Précommande · livrée en 7 à 10 jours »…) envoyé avec l'ajout au panier
 *    comme propriété de ligne { « Précommande » : « livraison en 7 à 10 jours » } : le panier affiche
 *    « Précommande · livraison en 7 à 10 jours », le paiement « Précommande: livraison en 7 à 10 jours ».
 *
 * 6. Pastille de taille (flair-mix.js) recalée quand la grille bouge (tailles épuisées masquées, police chargée…).
 *
 * 7. Téléphone : taille à choisir (rien de coché d'office). 8. Téléphone : bloc d'avis vide masqué.
 *
 * 9. Téléphone : délai de livraison visible avant le choix de la taille (résumé + point vert sur les tailles rapides).
 */
(() => {
  // ---------- 1. Barre d'achat collante (téléphone) ----------
  const phone = window.matchMedia('(max-width: 999px)');
  const sticky = document.querySelector('product-sticky-form');
  const payment = document.getElementById('MainPaymentContainer');

  if (sticky && payment) {
    const footer = document.querySelector('.shopify-section--footer');
    const state = { paymentVisible: true, paymentPassed: false, footerVisible: false, sizeChosen: false };

    const apply = () => {
      if (!phone.matches) return;
      // Flair : barre du bas visible seulement quand le vrai bouton est passé au-dessus de l'écran (choix d'Arthur),
      // et cachée au-dessus du pied de page
      const show = state.paymentPassed && !state.footerVisible;
      // après Focal, qui observe les mêmes éléments : notre décision est la dernière appliquée
      sticky.hidden = !show;
    };

    new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target === payment) {
          state.paymentVisible = entry.isIntersecting;
          state.paymentPassed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        } else {
          state.footerVisible = entry.isIntersecting;
        }
      });
      setTimeout(apply, 0);
    }).observe(payment);

    if (footer) {
      new IntersectionObserver((entries) => {
        state.footerVisible = entries[0].isIntersecting;
        setTimeout(apply, 0);
      }).observe(footer);
    }

    // Un vrai choix de taille par le client (pas la présélection automatique)
    const picker = document.querySelector('product-variants[form-id="' + sticky.getAttribute('form-id') + '"]:not(.product-sticky-form__variants)');
    if (picker) {
      picker.addEventListener('change', (event) => {
        if (!event.isTrusted) return;
        state.sizeChosen = true;
        setTimeout(apply, 0);
      });
    }

    phone.addEventListener('change', () => setTimeout(apply, 0));
  }

  // ---------- 3. Diaporama : rend la main aux transitions après le premier affichage ----------
  const heroDone = () => setTimeout(() => document.documentElement.classList.add('fx-hero-done'), 2500);
  if (document.readyState === 'complete') heroDone(); else window.addEventListener('load', heroDone, { once: true });

  // ---------- 4. WebMCP : décrit les formulaires pour les agents IA (attributs déclaratifs) ----------
  [
    ['#predictive-search-form, form.predictive-search__form', 'rechercher_produits', 'Rechercher une paire, une marque ou un modèle dans le catalogue Flair Store.', 'Mots-clés : marque, modèle ou référence'],
    ['#footer-newsletter', 'inscription_newsletter', 'Inscrire une adresse e-mail à la newsletter Flair Store (nouveautés et offres).', 'Adresse e-mail du client'],
    ['.newsletter-modal__form', 'inscription_newsletter_reduction', 'Inscrire une adresse e-mail à la newsletter Flair Store pour recevoir 10 % sur la première commande.', 'Adresse e-mail du client']
  ].forEach(([selector, name, description, paramDescription]) => {
    document.querySelectorAll(selector).forEach((form) => {
      form.setAttribute('toolname', name);
      form.setAttribute('tooldescription', description);
      const field = form.querySelector('input[type="email"], input[name="q"], input[type="search"]');
      if (field) field.setAttribute('toolparamdescription', paramDescription);
    });
  });

  // ---------- 5. Délai de livraison sur la ligne du panier ----------
  document.querySelectorAll('#custom-stock-status').forEach((wrapper) => {
    const root = wrapper.closest('.product__info') || document;
    const meta = root.querySelector('[form-id]');
    const formId = meta && meta.getAttribute('form-id');
    const form = (formId && document.getElementById(formId)) || root.querySelector('form[action*="/cart/add"]');
    const text = wrapper.querySelector('.stock-text');
    if (!form || !text) return;

    const input = document.createElement('input');
    input.type = 'hidden';
    input.disabled = true; // champ désactivé = non envoyé tant que le délai n'est pas connu
    form.appendChild(input);

    const sync = () => {
      // « Précommande · livrée en 7 à 10 jours » → clé « Précommande », valeur « livraison en 7 à 10 jours »
      const parts = text.textContent.replace(/\s+/g, ' ').trim().split(' · ');
      const known = !wrapper.classList.contains('is-empty') && parts.length === 2 && /livrée en/.test(parts[1]);
      input.name = known ? 'properties[' + parts[0] + ']' : '';
      input.value = known ? parts[1].replace('livrée en', 'livraison en') : '';
      input.disabled = !known;
    };

    new MutationObserver(sync).observe(text, { childList: true, characterData: true, subtree: true });
    new MutationObserver(sync).observe(wrapper, { attributes: true, attributeFilter: ['class'] });
    sync();
  });

  // ---------- 6. Pastille de taille recalée ----------
  // flair-mix.js ne la place qu'au chargement et au clic : on lui redemande (événement « change » non propagé,
  // seul son écouteur sur la liste le reçoit) dès que la grille change de taille ou que des tailles sont masquées.
  document.querySelectorAll('.product-form__option-selector[data-selector-type="block"] .block-swatch-list').forEach((list) => {
    // Tant que le client n'a pas touché aux tailles, la pastille saute directement à sa place (pas de glissement)
    let touched = false, timer = 0;
    list.addEventListener('pointerdown', () => { touched = true; });
    list.addEventListener('keydown', () => { touched = true; });
    const replace = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        const ind = list.parentElement.querySelector(':scope > .fx-ind');
        if (ind && !touched) ind.style.transition = 'none';
        list.dispatchEvent(new Event('change', { bubbles: false }));
        if (ind && !touched) setTimeout(() => { void ind.offsetWidth; ind.style.transition = ''; }, 60);
      }, 30);
    };
    if ('ResizeObserver' in window) new ResizeObserver(replace).observe(list);
    new MutationObserver(replace).observe(list, { subtree: true, attributes: true, attributeFilter: ['hidden', 'class', 'style'] });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(replace);
    window.addEventListener('load', replace, { once: true });
    setTimeout(replace, 1500);
  });

  // ---------- 7. Téléphone : la taille doit être choisie par le client ----------
  // Le thème coche d'office la 1re taille dispo (risque de mauvaise pointure). Sur téléphone, aucune taille n'est
  // cochée au départ : le bouton garde « Ajouter au panier » (choix d'Arthur), le prix affiche « À partir de … », et
  // l'ajout au panier est bloqué (la grille des tailles tremble) tant que le client n'a pas touché une taille.
  // Lancé après DOMContentLoaded pour passer après theme.js (chargé après ce fichier).
  const initSizeChoice = () => {
    if (!window.matchMedia('(max-width: 999px)').matches) return;
    if (new URLSearchParams(location.search).has('variant')) return; // lien vers une taille précise : on la garde
    const list = document.querySelector('.product__info .product-form__option-selector[data-selector-type="block"] .block-swatch-list');
    if (!list) return;
    if (list.querySelectorAll('.block-swatch:not([hidden])').length < 2) return;
    const radio = list.querySelector('.block-swatch__radio');
    const formId = radio && radio.getAttribute('form');
    if (!formId) return;

    const host = list.parentElement;
    const buttons = [...document.querySelectorAll('#AddToCart, #StickyAddToCart')];
    const priceList = document.querySelector('.product__info [data-product-price-list]');
    const from = (document.querySelector('.fx-reassure[data-fx-from]') || {}).dataset;
    let chosen = false;

    document.documentElement.classList.add('fx-need-size');
    list.querySelectorAll('.block-swatch__radio:checked').forEach((r) => { r.checked = false; });
    if (priceList && from && from.fxFrom) {
      priceList.innerHTML = '<span class="price price--large">À partir de ' + from.fxFrom + '</span>';
      const stickyPrice = document.querySelector('.product-sticky-form__price');
      if (stickyPrice) stickyPrice.textContent = 'Dès ' + from.fxFrom;
    }
    list.dispatchEvent(new Event('change', { bubbles: false })); // pastille cachée

    const nudge = () => {
      host.scrollIntoView({ behavior: 'smooth', block: 'center' });
      host.classList.remove('fx-shake');
      void host.offsetWidth;
      host.classList.add('fx-shake');
      setTimeout(() => host.classList.remove('fx-shake'), 1200);
    };

    window.addEventListener('submit', (event) => {
      // getAttribute : le formulaire contient un champ nommé « id », form.id renverrait ce champ
      if (chosen || !event.target.getAttribute || event.target.getAttribute('id') !== formId) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      nudge();
    }, true);

    // Filet de sécurité si le thème gère l'ajout au clic plutôt qu'à l'envoi du formulaire
    window.addEventListener('click', (event) => {
      if (chosen || !event.target.closest || !buttons.some((b) => b.contains(event.target))) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      nudge();
    }, true);

    list.addEventListener('change', (event) => {
      if (!event.isTrusted || chosen) return;
      chosen = true;
      document.documentElement.classList.remove('fx-need-size');
    });
  };

  // ---------- 9. Téléphone : délai visible avant le choix de la taille ----------
  // Tant qu'aucune taille n'est cochée (section 7), le voyant de stock est masqué : le client ne découvrait
  // « Précommande · 7 à 10 jours » qu'après avoir choisi. On affiche à la place un résumé tiré de la même réponse
  // api.flair-store.fr (le voyant la garde dans localStorage) : le délai s'il est le même pour toutes les tailles,
  // sinon « Selon la taille · livrée en 3 à 10 jours » et un point vert sous les tailles en Express ou en stock.
  const initDelayHint = () => {
    if (!document.documentElement.classList.contains('fx-need-size')) return;
    const wrapper = document.querySelector('.product__info #custom-stock-status');
    const list = document.querySelector('.product__info .product-form__option-selector[data-selector-type="block"] .block-swatch-list');
    if (!wrapper || !list) return;
    const key = 'flair-stock-' + wrapper.getAttribute('data-product-id');
    const hint = document.createElement('div');
    hint.className = 'fx-delay-hint';
    hint.hidden = true;
    wrapper.insertAdjacentElement('afterend', hint);

    const LABELS = {
      stock: ['in-stock', 'En stock', 'livrée en 5 à 7 jours'],
      '24h': ['within-24h', 'Express', 'livrée en 3 à 5 jours'],
      preorder: ['preorder', 'Précommande', 'livrée en 7 à 10 jours']
    };
    const line = (cls, label, delay) => '<div class="stock-indicator ' + cls + '"><span class="stock-dot"></span><span class="stock-text">' + label + ' <span class="stock-delay">· ' + delay + '</span></span></div>';

    let tries = 0;
    const render = () => {
      let data = null;
      try { data = JSON.parse(localStorage.getItem(key) || 'null'); } catch (error) {}
      if (!data || !data.length) { if (++tries < 40) setTimeout(render, 250); return; }
      const bySize = {};
      data.forEach((v) => { bySize[String(v.title).trim()] = v.stock === 'stock' || v.stock === '24h' ? v.stock : 'preorder'; });
      const kinds = new Set();
      list.querySelectorAll('.block-swatch:not([hidden])').forEach((swatch) => {
        const kind = bySize[swatch.textContent.trim()];
        if (!kind) return;
        kinds.add(kind);
        if (kind === 'preorder') swatch.removeAttribute('data-fx-delay'); else swatch.setAttribute('data-fx-delay', kind);
      });
      if (!kinds.size) return;
      if (kinds.size === 1) hint.innerHTML = line(...LABELS[[...kinds][0]]);
      else if (!kinds.has('preorder')) hint.innerHTML = line('in-stock', 'Express ou en stock', 'livrée en 3 à 7 jours');
      else hint.innerHTML = line('preorder', 'Selon la taille', 'livrée en 3 à 10 jours') + '<p class="fx-delay-hint__note"><span class="fx-delay-hint__dot"></span>Point vert : livrée plus vite (Express ou stock)</p>';
      hint.hidden = false;
    };
    render();
    setTimeout(render, 3000); // la réponse fraîche du serveur de stock remplace celle du cache
  };

  // ---------- 8. Téléphone : bloc d'avis masqué tant qu'il est vide (« Soyez le premier… ») ----------
  const hideEmptyReviews = () => {
    let tries = 0;
    const check = () => {
      document.querySelectorAll('.jdgm-widget, .jdgm-rev-widg').forEach((widget) => {
        const section = widget.closest('.shopify-section');
        if (!section) return;
        const empty = widget.classList.contains('jdgm--no-reviews') || /Soyez le premier|Be the first/i.test(widget.textContent);
        section.classList.toggle('fx-no-reviews', empty);
      });
      if (++tries < 20) setTimeout(check, 500);
    };
    check();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { initSizeChoice(); initDelayHint(); hideEmptyReviews(); });
  } else {
    initSizeChoice();
    initDelayHint();
    hideEmptyReviews();
  }

  // ---------- 2. Texte de collection repliable ----------
  document.querySelectorAll('[data-fx-coldesc]').forEach((box) => {
    const toggle = box.querySelector('[data-fx-coldesc-toggle]');
    const body = box.querySelector('.fx-coldesc__body');
    if (!toggle || !body) return;

    // Texte court : pas besoin de bouton
    if (body.scrollHeight <= body.clientHeight + 8) {
      box.classList.add('is-short');
      return;
    }

    toggle.hidden = false;
    toggle.addEventListener('click', () => {
      const open = box.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.firstElementChild.textContent = open ? 'Réduire' : 'Lire la suite';
    });
  });
})();
